/* eslint-disable global-require, class-methods-use-this */
// Libs / Helpers
import React, { Component } from 'react';
import QueueView from 'Components/QueueView';
import { getRegionList } from 'Apis/caseDataAPI.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EmptyState from 'Components/EmptyState/EmptyState';
import { setSearchOpenFlag } from 'Actions/drawerAction';
import DropDownList from 'Components/DropDownList/DropDownList';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getGeneralQueueMetaData, getAssignedCasesMetaData } from './configStructure.js';
import './LandingPage.scss';
import CaseCountDisplay from 'Components/CaseCountDisplay/CaseCountDisplay';
import GroupSearch from 'Components/GroupSearch';
import { isObject } from 'util';
import {
  getMyQueues,
  getDefaultQueueList,
  getExceptionQueue,
  getAssignedQueuesSummary,
  getGeneralQueuesSummary,
  getExceptionCasesCount,
  getMerchantMatchedFailCasesCount,
  getDefaultQueueCasesCount,
  getMerchantImageAllRegionCount,
  getSchemeExceptionCasesCount,
  getAmexOp1CasesCount,
  getMexicoQueueCount,
} from 'Apis/queueManagerApi.js';
import { loadState } from '../../store/browserStorage.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { VITE_AVAILABLE_QUEUES } from 'Constants/appEnvConstants';

export class LandingPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      regionDataList: [],
      queueList_1: [],
      queueList_2: [],
      queueList_3: [],
      queueListData: [],
      queueDefaultListData: [],
      queueExceptionListData: [],
      selectedInput: [
      ],
      emptyStateHeading: 'Unauthorized',
      emptyStateDescription: 'You are not authorized to view this content.',
      emptyStateNoPermissionsHeading: 'You do not have permission to view the queues',
      emptyStateNoPermissionsDesc:'Please contact support team for further assistance' ,
    };
    this.attachBindings();
  }

  componentWillMount() {
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    this.setState({
      generalQueueMetaData: getGeneralQueueMetaData(),
      assignedCasesMetaData: getAssignedCasesMetaData(userPermission),
      userPermission,
    });
  }
  componentWillReceiveProps(nextProps) {
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    if (this.state.userPermission == undefined) {
      this.setState({
        assignedCasesMetaData: getAssignedCasesMetaData(userPermission),
        userPermission
      });
    }
  }

  componentDidMount() {///modify 3 function
    let acquirerAccessList=getAcquirerAccessList();
    this.getRegionList();
    this.getQueueList();
    this.getExceptionQueue(acquirerAccessList);
    this.getAssignedQueuesSummary();
    this.getGeneralQueuesSummary();
    this.getExceptionQueueCount(acquirerAccessList);
    this.getMerchantMatchedFailCasesCount(acquirerAccessList);
    this.getDefaultQueueCasesCount();
    this.getMerchantImageAllRegionCount(acquirerAccessList);
    this.getSchemeExceptionCasesCount(acquirerAccessList);
    this.getAmexOp1CasesCount();
    this.getMexicoQueueCount();
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  resetDropDownList(nextProps) {
    if (this.props.selectedOption !== nextProps.selectedOption) {
      this.setState({
        selectedOption: nextProps.selectedOption,
      });
    }
  }
  resetScrollPos() {
    this.state.scrollPos = 0;
  }

  attachBindings() {
    this.getQueueList = this.getQueueList.bind(this);
    this.getDefaultQueueList = this.getDefaultQueueList.bind(this);
    this.getExceptionQueue = this.getExceptionQueue.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.getAssignedQueuesSummary = this.getAssignedQueuesSummary.bind(this);
    this.getGeneralQueuesSummary = this.getGeneralQueuesSummary.bind(this);
    this.getRegionList = this.getRegionList.bind(this);
    this.fetchAssignedCasesCount = this.fetchAssignedCasesCount.bind(this);
    this.getExceptionQueueCount = this.getExceptionQueueCount.bind(this);
    this.getMerchantMatchedFailCasesCount = this.getMerchantMatchedFailCasesCount.bind(this);
    this.getDefaultQueueCasesCount = this.getDefaultQueueCasesCount.bind(this);
    this.getMerchantImageAllRegionCount = this.getMerchantImageAllRegionCount.bind(this);
    this.getSchemeExceptionCasesCount = this.getSchemeExceptionCasesCount.bind(this);
    this.getAmexOp1CasesCount = this.getAmexOp1CasesCount.bind(this);
    this.getMexicoQueueCount = this.getMexicoQueueCount.bind(this);
  }
  goToQueueLanding = (queueId) => {
    const regionCode = this.state.selectedInput.value.regionCode;
    const acquirerAccessCode = this.state.selectedInput.value.acquirerAccessCode;
    VITE_AVAILABLE_QUEUES.indexOf(queueId) == -1 ? this.props.history.push(`/queue-management-landing?region=${regionCode}&queueid=${queueId}&acquirerAccessCode=${acquirerAccessCode}`) : (queueId == 15 ? this.props.history.push(`/queue/${queueId}?regionCode=${regionCode}`) : this.props.history.push(`/queue/${queueId}`));
  };
  handleSelectionChange(selectedItem) {
    if (selectedItem) {
      this.setState({ selectedInput: selectedItem });
    }
    this.getDefaultQueueList(selectedItem.value);
  }
  getQueueList() {
    return getMyQueues()
      .then((apiResponse) => {
        const queueListData = apiResponse.data;

        this.setState({
          queueList_1: queueListData,
        });
      })
      .catch((error) => {
        console.log('error received while fetching data columns based on queue page', error);
      });
  }
  getDefaultQueueList(regionListValue) {
    return getDefaultQueueList(regionListValue.regionCode,'',regionListValue.acquirerAccessCode)
      .then((apiResponse) => {
        const queueDefaultListData = apiResponse.data;

        this.setState({
          queueList_2: queueDefaultListData,
        });
      })
      .catch((error) => {
        this.setState({
          queueList_2: [],
        });

        console.log('error received while fetching data columns based on queue page', error);
      });
  }

  getExceptionQueue(acquirerAccessList) {
    return getExceptionQueue(acquirerAccessList)
      .then((apiResponse) => {
        
        let acquirerList=getAcquirerAccessList();
        const queueExceptionListData2 = apiResponse.data;
        let queueExceptionListData;
        if((acquirerList.includes('MXP') || acquirerList.includes('MXI')) && !acquirerList.includes('GPN')){
          queueExceptionListData = queueExceptionListData2.filter((queue) => queue.queueName != "Amex Optblue Op1 Cases & Amex One Point Cases");
        }else{
          queueExceptionListData= queueExceptionListData2;
        }

        this.setState({
          queueList_3: queueExceptionListData,
        });
      })
      .catch((error) => {
        console.log('error received while fetching data columns based on queue page', error);
      });
  }
  /**
       * This method returns count of cases in general queues
       */
  getGeneralQueuesSummary() {
    let acquirerAccessList = getAcquirerAccessList();
    if(acquirerAccessList.length !== 0){
    getGeneralQueuesSummary(acquirerAccessList).then((response) => {
      this.setState({
        generalQueueSummary: response.data,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }
  }

  getAssignedQueuesSummary() {
    /**
     * Thid method returns count of of cases in assigned queus
     */
    let acquirerAccessList = getAcquirerAccessList();
    if(acquirerAccessList.length !== 0){
    getAssignedQueuesSummary(acquirerAccessList).then((response) => {
      this.setState({
        assignedQueueSummary: response.data,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }
  }
  getRegionList() {
    let acquirerAccessList = getAcquirerAccessList();
    if(acquirerAccessList.length !== 0){
    return getRegionList(acquirerAccessList)
      .then((apiResponse) => {
        const formattedRegionList = apiResponse.data.map((item) => {
         let regionListValue = {regionCode:item.regionCode, acquirerAccessCode:item.acquirerAccessCode };
          return {
            text: item.defaultQueueName,         
            value: regionListValue,
          };
          
          console.log(item.defaultQueueName);
          
        });

        // TODO:  The default dropdown list should be first till now, but this should be changed to user specific.
        this.setState({
          regionDataList: formattedRegionList,
          selectedInput: formattedRegionList[0],
        });

        this.getDefaultQueueList(formattedRegionList[0].value);
      })
      .catch((error) => {
        console.log('error received while fetching list of regions', error);
      });
    }
  }

  fetchAssignedCasesCount(count) {
    this.setState({
      assignedQueueSummary: count
    });
  }

  getExceptionQueueCount(acquirerAccessList) {
    getExceptionCasesCount(acquirerAccessList).then((response) => {
      const exceptionCasesCount = response.data.map((item) => {
        return {
          count : item.count,
        };
      });
      this.setState({
        exceptionCasesCount,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getMerchantMatchedFailCasesCount(acquirerAccessList) {
    getMerchantMatchedFailCasesCount(acquirerAccessList).then((response) => {
      const merchMatchCasesCount = response.data.map((item) => {
        return {
          count : item.count,
        };
      });
      this.setState({
        merchMatchCasesCount,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getDefaultQueueCasesCount() {
    getDefaultQueueCasesCount().then((response) => {
      const defaultCasesCount = response.data.map((item) => {
        return {
          count : item.count,
        };
      });
      this.setState({
        defaultCasesCount,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getMerchantImageAllRegionCount(acquirerAccessList) {
    getMerchantImageAllRegionCount(acquirerAccessList).then((response) => {
      const merchImageCasesCount = response.data.map((item) => {
        return {
          count : item.count,
        };
      });
      this.setState({
        merchImageCasesCount,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getSchemeExceptionCasesCount(acquirerAccessList) {
    getSchemeExceptionCasesCount(acquirerAccessList).then((response) => {
      const schemeCasesCount = response.data.map((item) => {
        return {
          count : item.count,
        };
      });
      this.setState({
        schemeCasesCount,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getAmexOp1CasesCount() {
    getAmexOp1CasesCount().then((response) => {
      const amexCasesCount = response.data.map((item) => {
        return {
          count : item.count,
        };
      });
      this.setState({
        amexCasesCount,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getMexicoQueueCount() {
    getMexicoQueueCount().then((response) => {
    const mexicoCasesCount = response.data.map((item) => {
      if(item.queueId == 68){
        return {
          count : 0,
        }
      }else{
      return {
        count : item.count,
      };
    }
      });
      this.setState({
        mexicoCasesCount,
      });
    }).catch((error) => {
     console.log('error received while fetching data columns based on queue page', error);
   });
  }

  render() {
    let count = [];
    let totalCount = [];
    let acquirerList=getAcquirerAccessList();
    if(acquirerList.includes('GPN') && (acquirerList.includes('MXP') || acquirerList.includes('MXI'))){
      totalCount = this.state.exceptionCasesCount && this.state.merchMatchCasesCount && this.state.defaultCasesCount && this.state.merchImageCasesCount && this.state.schemeCasesCount && this.state.amexCasesCount && this.state.mexicoCasesCount &&
      count.concat([...this.state.exceptionCasesCount, ...this.state.merchMatchCasesCount, ...this.state.defaultCasesCount, ...this.state.merchImageCasesCount, ...this.state.schemeCasesCount, ...this.state.amexCasesCount,...this.state.mexicoCasesCount,]);
    }else if (acquirerList.includes('GPN') &&  !(acquirerList.includes('MXP') || acquirerList.includes('MXI'))){
      totalCount = this.state.exceptionCasesCount && this.state.merchMatchCasesCount && this.state.defaultCasesCount && this.state.merchImageCasesCount && this.state.schemeCasesCount && this.state.amexCasesCount &&
      count.concat([...this.state.exceptionCasesCount, ...this.state.merchMatchCasesCount, ...this.state.defaultCasesCount, ...this.state.merchImageCasesCount, ...this.state.schemeCasesCount, ...this.state.amexCasesCount]);
    }else if((acquirerList.includes('MXP') || acquirerList.includes('MXI')) && !acquirerList.includes('GPN')){
       totalCount = this.state.exceptionCasesCount && this.state.merchMatchCasesCount && this.state.schemeCasesCount && this.state.mexicoCasesCount &&
       count.concat([...this.state.exceptionCasesCount, ...this.state.merchMatchCasesCount, ...this.state.schemeCasesCount, ...this.state.mexicoCasesCount]);
    }
   
    const workableCountArr = totalCount && totalCount.map((item) => { return item.count });
    const workableCount = workableCountArr && workableCountArr.reduce((a, b) => a + b, 0);
    if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.canViewAll && acquirerList.length !== 0) {
      return (
        <section
          className="case-landing-container"
        >
          <div className={this.props.isSearchActive ? 'main-content--header secondary-header' : 'main-content--header'} style={{ zIndex: 1 }}>
            <div className="flex-left">
              <h1 className="title">Home</h1>
            </div>
          </div>
          {
          this.state !== undefined && <div className="main-content--wrapper">
            <div className="homepage">
              <div>
                {this.state.generalQueueMetaData !== undefined && this.state.generalQueueMetaData.dataColumns !== undefined && this.state.generalQueueMetaData.dataColumns?.length > 0 &&
                  this.state.generalQueueMetaData.dataColumns?.map((component, index) => {
                    const componentId = component.id;
                    let keyIndex = '';
                    if (componentId !== undefined) {
                      keyIndex = `queueList_${componentId}`;
                    }
                    return (
                      <div key={index}>
                        {
                          this.state.generalQueueSummary === undefined && workableCount === undefined && <BVLoader20 />
                        }

                        {component.displayType === 'SUMMARY' && this.state.generalQueueSummary !== undefined  &&  <div>
                          <div>
                            <h1 className="title title-padding">
                              {component.title}
                            </h1>
                          </div>
                          <div className="align-summary">
                            <CaseCountDisplay
                              dataColumns={component.columns}
                              caseCountData={this.state.generalQueueSummary}
                              workableCount={workableCount}
                            />
                          </div>
                        </div>
                        }
                        {
                          component.displayType === 'QUEUE_VIEW' && <div>

                            <h4 className="topic-header">{component.title}</h4>
                            {isObject(component.dropDownselection) && this.state.selectedInput.text && <div className="dropdown-view"><DropDownList
                              dropDownList={this.state[component.dropDownselection.defSelectKey]}
                              selectedItemText={this.state.selectedInput.text}
                              selectDropdownItem={this.handleSelectionChange}
                              extraStyle={{ left: 5, width: 200 }}
                              wrapperButtonStyle={{ left: 0 }}
                            />
                            </div>
                            }
                            {
                              this.state[keyIndex] === undefined && <BVLoader20 />
                            }
                            {this.state[keyIndex] !== undefined && this.state[keyIndex].map((row, index) => {
                              const rowLen = this.state[keyIndex].length;
                              return (<div key={index}>
                                <QueueView
                                  id={row.queueId}
                                  name={row.queueName}
                                  onViewClick={() => this.goToQueueLanding(row.queueId)}
                                  count={row.count}
                                  isBorder={rowLen === index + 1 ? true : false} />
                              </div>);
                            })}
                            {
                              this.state[keyIndex] !== undefined && this.state[keyIndex].length === 0 && <span className="message-view">No queues available.</span>
                            }
                          </div>
                        }
                      </div>
                    );
                  })}
              </div>
              {this.state.assignedCasesMetaData.dataColumns !== undefined && <div className="summary-padding">

                {this.state.assignedCasesMetaData !== undefined && this.state.assignedCasesMetaData.dataColumns?.length > 0 && this.state.assignedCasesMetaData.dataColumns?.map((component, index) => {
                  return (
                    <div key={index}>
                      {component.displayType === 'SUMMARY' && this.state.assignedQueueSummary !== undefined && <div>
                        <div>
                          <h1 className="title">
                            {component.title}
                          </h1>
                        </div>
                        <div>
                          <CaseCountDisplay
                            dataColumns={component.columns}
                            caseCountData={this.state.assignedQueueSummary}
                          />
                        </div>
                      </div>
                      }
                    </div>
                  );
                })}
                {
                  <div>
                    <GroupSearch
                      fetchAssignedCasesCount={this.fetchAssignedCasesCount}
                      defaultGroupTitle='All Analysts'
                      selectionTitle='Groups'
                      searchTitle='Search'
                      searchPlaceholder='Search For Analysts'
                    />
                  </div>
                }
              </div>}
            </div>
           
          </div>}
        </section>
      );
    } else {
      return (
        <EmptyState
        translations={{ emptyStateHeading:acquirerList.length === 0 && this.props.user.parsedPermissions.queue.canViewAll ? this.state.emptyStateNoPermissionsHeading : this.state.emptyStateHeading, emptyStateDescription:acquirerList.length === 0 &&  this.props.user.parsedPermissions.queue.canViewAll ? this.state.emptyStateNoPermissionsDesc :  this.state.emptyStateDescription }}
        />
      );

    }
  }

}

/* eslint-enable global-require, class-methods-use-this */

const mapStateToProps = (state) => ({
  filters: state.searchFilter.filters,
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFilterElements: (searchTypeId) => {
      dispatch(fetchFilterElements(searchTypeId));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage));
